<div class="cookie-consent-container">
    <h2 i18n>Cookie-Einwilligung</h2>
    <p i18n>Wir verwenden Cookies, um Technische Notwendige Dinge auf unserer Website umzusetzen. Indem du auf
        "Akzeptieren"
        klicken, stimmst du der Verwendung von Cookies zu.
    </p>
    <p i18n>
        Zudem verwenden wir Sentry zur Fehleranalyse, um die Qualität unserer Website zu verbessern.
        Diese kannst du mit einem Klick auf "nur Notwendige" deaktivieren.
    </p>
    <p>Hier findest du unsere <a href="/privacy-policy">Datenschutzerklärung</a></p>
    <div mat-dialog-actions class="actions">
        <button mat-raised-button (click)="necessaryAccept()" i18n>nur Notwendige</button>
        <button mat-raised-button color="primary" (click)="accept()" i18n class="accept">Akzeptieren</button>
    </div>
</div>